import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Company } from 'src/app/company.model';
import { Globals } from 'src/app/globals';
import { Clipboard } from '@angular/cdk/clipboard';


@Component({
  selector: 'app-dns-config',
  templateUrl: './dns-config.component.html',
  styleUrls: ['./dns-config.component.css']
})
export class DnsConfigComponent implements OnInit {

  constructor(private http: HttpClient, private globals:Globals,private clipboard: Clipboard, private _snackBar: MatSnackBar) { }

  checkingSpf = true;
  checkingDkim = true;
  spf = false;
  spfRecord="";
  spfNewRecord="";
  spfReason = "";
  dkim = false;
  dkimReason = "";
  domain = ""
  roundtrip = false;
  ngOnInit(): void {
    this.getDomain();  
  }
  async getDomain(){
    let param = new HttpParams();
    param = param = param.append('AuthToken', await this.globals.getAuthToken());
    param = param.append('UserName', this.globals.getSystemUserName());
    this.http.get<any>(this.globals.getApiUrl() + 'api/getSPMailCompanyInfo.php', { params: param }).subscribe({
    next: data => {this.domain = data.DomainList[0]; this.checkDns(); this.roundtrip = data.ExtraSettingsDomainList[0].UseCustomServerFlag.includes("Y"); 
    },
      error: error => { console.error('There was an error!');}
    });
  }
  checkDns(){this.checkingDkim = true; this.checkingSpf = true; this.checkSpf(); this.checkDkim();}
  checkSpf(){
    this.spfReason = "";
    console.log(this.domain);
    let domain = new FormData;
      domain.append('domain', this.domain);
    this.http.post<any>(this.globals.getServicesUrl() + "dns/spfCheck", domain).subscribe({
      next: data => {
        this.spf = true;
        this.spfReason = "SPF looks good";
        this.checkingSpf = false;
      },
      error: error => {
        this.spf = false;
        switch(error.error.ErrorMsg){
          case "Cant find include:stayprivatemail.com in SPF record": 
          this.spfReason = 'Entry not found in SPF record'; 
          this.spfRecord = error.error.Record; 
          this.spfNewRecord = error.error.Record.slice(0, -4)+"include:spmail.com "+error.error.Record.slice(-4);
          break;       
          case "Invalid SPF record": this.spfReason = 'SPF record is not valid'; break;       
          case "Email not found": this.spfReason = 'SPF record not found'; break;       
          case "No SPF record found": this.spfReason = 'SPF record not found'; break;       
          case "Failed to reach server. Please try again.": this.spfReason = "We couldn't reach your mail server. Please try again."; break; 
                
        }   
        this.checkingSpf = false;
      }
    });
  }
  checkDkim(){
    this.dkimReason = "";
    console.log(this.domain);
    let domain = new FormData;
    domain.append('domain', this.domain);
    this.http.post<any>(this.globals.getServicesUrl() + "dns/dkimCheck", domain).subscribe({
      next: data => {
        this.dkim = true;
        this.dkimReason = "DKIM looks good";
        this.checkingDkim = false;
      },
      error: error => {
        console.log(error.error.ErrorMsg)
        this.dkim = false;
        switch(error.error.ErrorMsg){
          case "DKIM Record does not match": this.dkimReason = 'DKIM record found but pointing to the wrong place'; break;          
          case "No DKIM Record found": this.dkimReason = 'DKIM record not found'; break;
          case "Email not found": this.dkimReason = 'DKIM record not found'; break;             
          case "Failed to reach server. Please try again.": this.dkimReason = "We couldn't reach your mail server. Please try again."; break; 
        }        
        this.checkingDkim = false;
        
      }
    });
  }
  copy(copyVariable) {
    this.clipboard.copy(copyVariable);
    this._snackBar.open("Copied!", "OK", { duration: 3000 });
  }
  

}
